/**
 * @file   page-config.js
 * @author rongtan<rongtan@baidu.com>
 * @date   2020-12-20
 */
import {PAGE} from '@config/index';

export default {
    [PAGE.home]: {
        name: 'home'
    },
    [PAGE.appraisalPromote]: {
        name: 'shoubai_ad'
    },
    // 商品详情
    [PAGE.goodsDetail]: {
        name: 'goodsdetail'
    },
    // 拉新活动
    [PAGE.pullUserActivity]: {
        name: 'growthactivity'
    },
    [PAGE.couponActivity]: {
        name: 'couponActivity'
    },
    // H5 鉴定师
    [PAGE.appraiser]: {
        name: 'appraiser'
    },
    // 鉴定裂变
    [PAGE.appraisalHelp]: {
        name: 'myassistance'
    },
    [PAGE.appraisalShare]: {
        name: 'myInvite'
    },
    // 短视频
    '/video/:id': {
        name: 'video'
    },
    // 小视频
    '/svideo/:id': {
        name: 'svideo'
    },
    // 鉴定落地页-图片
    '/aappraisal/:id': {
        name: 'appraisalPic'
    },
    // 鉴定落地页-视频
    '/vappraisal/:id': {
        name: 'appraisalVideo'
    },
    // 长图文
    '/article/:id': {
        name: 'article'
    },
    // 短图文
    '/sarticle/:id': {
        name: 'sarticle'
    }
};
